<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="dataTable"
      :no-data-text="$t('common.nodata')"
      hide-default-footer
      fixed-header
      class="custom-price-data-table gray10"
      :header-props="{ 'sort-icon': '$sortIcon' }"
    >
      <template v-slot:item.createTime="{ item }">
        <div>
          {{ item.createTime | dateTimeFilter }}
        </div>
      </template>
      <template v-slot:item.symbol="{ item }">
        <div>
          {{ item.symbol }}
        </div>
      </template>
      <template v-slot:item.trxType="{ item }">
        <div>
          {{ item.type }}
        </div>
      </template>
      <template v-slot:item.amount="{ item }">
        <div style="direction: ltr">
          {{ $thousandMask(item.amount, coinScales[item.symbol]) }}
        </div>
      </template>
      <template v-slot:item.fee="{ item }">
        <div>
          {{ $thousandMask(item.fee, coinScales[item.symbol]) }}
        </div>
      </template>
      <template v-slot:item.status="">
        <div>
          {{ $t("transactions.completed") }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import dayjs from "dayjs";
import $thousandMask from "@/mixins/thousandMask";

export default {
  mixins: [$thousandMask],
  props: {
    dataTable: {
      type: Array
    },
    current: {
      type: Number
    },
    coinScales: {
      type: Object
    },
    loading: {
      type: Boolean
    },
    pageSize: {
      type: Number
    }
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("transactions.trxTime"),
          value: "createTime",
          align: "center"
        },
        {
          text: this.$t("transactions.crypto"),
          value: "symbol",
          align: "center"
        },
        {
          text: this.$t("transactions.trxType"),
          value: "trxType",
          align: "center"
        },
        {
          text: this.$t("transactions.amount"),
          value: "amount",
          align: "center"
        },
        { text: this.$t("transactions.fee"), value: "fee", align: "center" },
        {
          text: this.$t("transactions.status"),
          value: "status",
          align: "center"
        }
      ]
    };
  },
  filters: {
    dateTimeFilter(date) {
      return (
        dayjs(date).format("HH:mm") + " - " + dayjs(date).format("YYYY/MM/DD")
      );
    }
  },
  methods: {
    changePageNumber(pageIndex) {
      this.$emit("changePage", pageIndex);
    }
  }
};
</script>

<style lang="scss" scoped></style>
